import api from './index';

let exports = {};

// 统计-设备分类的服务商各机构服务统计报表
exports.getGoodsCatServicerStatisList = function (data, callback) {
    api.post('/statis/work/goodsCat/servicer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-设备分类的服务商各机构服务统计报表-导出url
exports.getGoodsCatServicerStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/goodsCat/servicer/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// - 【设备明细维修统计】 and 【机构待修设备明细统计表】
exports.statisShopDeviceSvcSubNoStatisList = function (data, callback) {
    api.post('/statis/work/svcSubNo/statis/list/get/by/comId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.saveShopDeviceStatisForExport = function (data, callback) {
    api.post('/statis/work/statis/export/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// - 【服务商服务统计报表】
exports.getServicerStatisList = function (data, callback) {
    api.post('/statis/work/servicer/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 设备维保明细
exports.getDeviceMaintainList = function (data, callback) {
    api.post('/statis/work/servc/work/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备维保明细导出
exports.getDevicePartMaintainStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/device/part/maintain/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevicePartMaintainList = function (data, callback) {
    api.post('/statis/work/device/part/maintain/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-设备维修统计-导出url
exports.statisGoodsCatVendorFulfillList = function (data, callback) {
    api.post('/statis/work/goodsCat/vendor/fulfill/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-服务商服务客观评价报表
exports.getServicerPSQMStatisList = function (data, callback) {
    api.post('/statis/work/servicer/psqm/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 统计-服务商服务客观评价报表
exports.ShopDeviceSvcNoToBeRepared = function (data, callback) {
    api.post('/statis/work/statis/list/downLoad/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备运行情况统计
exports.getDeviceRunStatisList = function (data, callback) {
    api.post('/statis/work/shop/device/run/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceRunStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/shop/device/run/statis/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 维修趋势
exports.getShopDeviceFaultTrendStatisList = function (data, callback) {
    api.post('/statis/work/shop/device/fault/trend/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceFaultTrendStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/shop/device/fault/trend/statis/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//设备维保统计
exports.getShopDeviceProductMaintStatisList = function (data, callback) {
    api.post('/statis/work/shop/device/product/maint/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceProductMaintStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/shop/device/product/maint/statis/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务商分类维保情况
exports.getServicerDevcCatMaintainStatisList = function (data, callback) {
    api.post('/statis/work/servicer/devcCat/maintain/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务商分类维保情况导出
 exports.getServicerDevcCatMaintainStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/servicer/devcCat/maintain/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务商维保情况
exports.getServicerMaintainStatisList = function (data, callback) {
    api.post('/statis/work/servicer/maintain/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 服务商维保情况导出
exports.getServicerMaintainStatisListExportUrl = function (data, callback) {
    api.post('/servicer/maintain/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/statisWork.js
// module id = 72
// module chunks = 0